<template>
	<div>
		<vxe-modal v-model="modal_model" :title="title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			title: {
				default: () => {
					return '明细'
				}
			},
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_width:600,
				modal_height:500,
				list_footerField:[
					{field:'amt',toFixed:2},
					{field:'needamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50,
					},{
						field: 'paymentcode',
						title: '单据编码',
						sortable:true,
					},
					{
						field: 'amt',
						title: '付款金额',
						sortable:true,
					},
					{
						field: 'needamount',
						title: '应付金额',
						sortable:true,
					},
					{
						field: 'diff',
						title: '差额',
						sortable:true,
						formatter({row}){
							if(row.amt){
								return parseFloat(row.amt) - parseFloat(row.needamount)
							}
							
						}
					},
					{
						field: 'cdSign',
						title: '收支方向',
						sortable:true,
						formatter({cellValue}){
							if(cellValue==1){
								return '支出'
							}
							if(cellValue==0){
								return '收入'
							}
							return ''
						}
						
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = JSON.parse(JSON.stringify(this.data))
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>